import React from "react";
import {fetchDataEntity} from "../../../api/entity-data";
import ControllerSelectBox from "../../../components/Common/ControllerInput/ControllerSelectBox";
import {ArrayToSelectOption, FilterArrayByKey, SortData} from "../../../api/fn";
import Page from "../../../layout/web/Page";
import Title from "../../../components/Common/Title";
import Connector from "../../../redux/connector";
import {PostToPbx} from "../../../api/http-post";
import moment from "moment";
import GridContainer from "../../../components/Common/dashboard/Grid/GridContainer";
import GridItem from "../../../components/Common/dashboard/Grid/GridItem";
import {Button, Col, Row} from "antd";
import SearchComboBox from "../../../components/Common/SearchBoxSelectionImage/SearchComboBox";
import BoxSelect from "../../../components/Common/ControllerInput/BoxSelect";


class DeductionEmployeeRegister extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Companies: [],
            Attributes:[],
            Projects: [],
            Periods: [],
            Employees: [],
            Sites: [],
            Files:[],

            selectedCompany: "",
            selectedProject: "",
            selectedSite: "",
            selectedEmployee: "",
            deductionAmount: 0,
            deductionReason:"",

            step: 0,
            showStep: false,
        }

    }

    componentDidMount = async () => {
        await fetchDataEntity("Companies", "client/entity", "company", this)
        await fetchDataEntity("Projects", "", "", this, undefined, "common/entity/modules/list");
        await fetchDataEntity("Files", "", "", this,undefined,"common/entity/files/list");
        /*await fetchDataEntity("Databases", "", "", this,undefined,"common/entity/databases/list");
        await fetchDataEntity("Attributes", "", "", this,undefined,"common/entity/attributes/list");
        await this.initialReload()*/
    }
    requestNewDeduction = () => {
        this.setState({
            component: "form"
        })
    }
    handleChangeInput = async ( key,value) => {
        console.log("handleChangeInput > ",key," > ",value)
        this.setState({
            [key]: value,
        });
        if (key === "selectedProject" && this.state.selectedCompany !== "") {
            await this.loadSelectedDatabaseAttributes();
            await this.loadSelectedContractInfo();
        }
    }
    handleGetInputValue = (key) => {
        if (typeof this.state[key] === "undefined") {
            return ""
        }
        return this.state[key];
    }
    loadSelectedDatabaseAttributes = async () => {
        let conditions=[
            {key:"org",val:""}
        ]
        await fetchDataEntity("Databases", "", "", this,undefined,"common/entity/databases/list");
        await fetchDataEntity("Attributes", "", "", this,undefined,"common/entity/attributes/list");
    }
    loadSelectedContractInfo=async ()=>{
        let _this = this;
        let state = this.state;
        let hub = {
            Org: state.selectedCompany,
            Module: "contract",
            Ref: state.selectedProject,
        }

        let endpoint = "/payroll/contract/fetch-data"
        await PostToPbx(hub, endpoint, async (output) => {
            console.log("loadInitialData > ", hub, output)
            let data = output.RESULT;
            let tmp = _this.state;
            tmp.Periods =  data.TermsPayCycle;
            tmp.Sites = data.TermsSite;

            /*tmp.DataPeriod = data.TermsPeriod;
            tmp.DataDesignation = data.TermsDesignation;
            tmp.DataPayCycle = data.TermsPayCycle;
            tmp.DataSite = data.TermsSite;
            tmp.DataRate = data.TermsRate;
            tmp.DataRateSpecific = data.TermsRateSpecific;
            tmp.DataSlot = data.TermsSlot;
            tmp.DataSiteDesignation = data.TermsSiteDesignation;
            tmp.DataShift = data.TermsShift;
            tmp.DataCondition = data.TermsCondition;*/
            _this.setState(tmp);

            console.log("loadSelectedContractInfo > ", tmp.Sites, " > ", tmp.Periods)
        });
    }

    submitDeduction=async ()=>{
        let _this = this;
        let state = this.state;
        /*
        selectedCategory: "deduction"
​
selectedCompany: "C100015"
​
selectedEmployee: "234"
​
selectedPeriod: "1#2021-03-01#2021-03-31#2021-03-31"
​
selectedProject: "Cleaning of Public Toilets/Bath Houses - Group 3"
​
selectedSite: "Athlone Bath Houses"
         */
        console.log("submitDeduction state > ",state)
        let arr=state.selectedPeriod.split("#");

        let amount=0;
        if(state.selectedCategory!=="deduction"){
            const str =`-${state.deductionAmount}`;
            amount =parseFloat(str)
        }else{
            amount =parseFloat(state.deductionAmount)
        }
        let hub={};
        hub.Org = state.selectedCompany;
        hub.PayCyclePeriod = `${arr[1]}#${arr[2]}#${arr[0]}`
        hub.WorkerRef =state.selectedEmployee;
        hub.Project = state.selectedProject;
        hub.Amount = amount;
        hub.PayDate = arr[3];
        hub.Site = state.selectedSite;
        hub.Reason = state.deductionReason;

        // `${row.Period}#${row.StartDate}#${row.EndDate}#${row.PayDate}`

        console.log("submitDeduction send > ", hub)

        let endpoint = "/clock/deduction/new"
        await PostToPbx(hub, endpoint, async (output) => {
            let data = output.RESULT;

            console.log("submitDeduction response > ", data)
            alert("Thank you, yours deduction have been recorded!")
        });
    }

    renderCompanyBox = () => {
        let ls = [];
        ls = FilterArrayByKey( this.state.Companies,{})
        ls = ArrayToSelectOption(ls,["CustomerNumber"],["Name"])
        return (
            <ControllerSelectBox
                handleInput2={this.handleChangeInput}
                getHandleValue={this.handleGetInputValue}
                ls={ls}
                label={"Company"}
                name={"selectedCompany"}
            />
        )
    }
    renderProjectBox = () => {
        let ls = [];
        for(let i in this.state.Projects){
            let row = this.state.Projects[i];
            if(row.org!==this.state.selectedCompany){continue}
            ls.push(row)
        }
        ls = FilterArrayByKey( ls,{})
        ls = ArrayToSelectOption(ls,["name"],["name"])
        return (
            <ControllerSelectBox
                handleInput2={this.handleChangeInput}
                getHandleValue={this.handleGetInputValue}
                ls={ls}
                label={"Project"}
                name={"selectedProject"}
            />
        )
    }
    renderPayCycleBox = () => {
        const shortDisplayDate=(dateIn)=>{
            return moment(dateIn, "YYYY-MM-DD").format("DD MMM YYYY")
        }
        let ls = [];
        for(let i in this.state.Periods){
            let row = this.state.Periods[i];
            if(row.Org!==this.state.selectedCompany){continue}
            if(row.Ref!==this.state.selectedProject){continue}
            //todo let make display name
            const startDate =shortDisplayDate(row.StartDate);
            const endDate =shortDisplayDate(row.EndDate);
            const payDate = shortDisplayDate(row.PayDate);
            row.DisplayLabel = `${row.Period}. -> Start: ${startDate} -> End: ${endDate} -> Pay date: ${payDate}`;
            row.DisplayValue = `${row.Period}#${row.StartDate}#${row.EndDate}#${row.PayDate}`
            ls.push(row)
        }
        ls = FilterArrayByKey( ls,{})
        ls = ArrayToSelectOption(ls,["DisplayValue"],["DisplayLabel"])
        return (
            <ControllerSelectBox
                handleInput2={this.handleChangeInput}
                getHandleValue={this.handleGetInputValue}
                ls={ls}
                label={"Pay Circle period"}
                name={"selectedPeriod"}
            />
        )
    }
    renderCategory=()=>{
        let ls=[
            {key:"deduction",val:"Deduction"},
            {key:"increase",val:"Increase"}
        ]
        return (
            <ControllerSelectBox
                handleInput2={this.handleChangeInput}
                getHandleValue={this.handleGetInputValue}
                ls={ls}
                label={"Category"}
                name={"selectedCategory"}
            />
        )
    }
    renderSiteBox = () => {
        let ls = [];
        for(let i in this.state.Sites){
            let row = this.state.Sites[i];
            if(row.Org!==this.state.selectedCompany){continue}
            if(row.Module!=="contract"){continue}
               if(row.Ref!==this.state.selectedProject){continue}
            ls.push(row)
        }
        ls = FilterArrayByKey( ls,{})
        ls = ArrayToSelectOption(ls,["Name"],["Name"])
        return (
            <ControllerSelectBox
                handleInput2={this.handleChangeInput}
                getHandleValue={this.handleGetInputValue}
                ls={ls}
                label={"Site"}
                name={"selectedSite"}
            />
        )
    }

    getEmployeeOption=(attributes,data)=>{
        let name="";
        let x=0;
        for(let i in attributes){
            let field = attributes[i];
            if(x===0){
                name=data[field]
            }else{
                name=name+" "+data[field]
            }
            x++;
        }

        return name;
    }

    renderEmployeeBox = () => {
        let ls = [];
        let attributes = [];
        let storeAttributes = SortData("position",this.state.Attributes)
        for(let i in storeAttributes) {
            let row = storeAttributes[i];
            if (row.org !== this.state.selectedCompany) {
                continue
            }

            if (row.module !== this.state.selectedProject) {
                continue
            }


            if(!row.displayselection){
                continue
            }
            attributes.push(row.fieldname)
        }

        const cleanKey=(key1)=>{
            key1=key1.toLowerCase();
            key1 = key1.trim();
            return key1
        }

        console.log("this.state.Files > ",this.state.Files," > ",attributes)
        for(let i in this.state.Databases){
            let row = this.state.Databases[i];
            if(row.org!==this.state.selectedCompany){continue}
            if(row.module!==this.state.selectedProject){continue}

            const str = JSON.stringify(row);

            if(str.indexOf("CB0030")!==-1){
                console.log("2 DEBUGING SITE :> ",row.data.Site ," !== ",this.state.selectedSite ,"| ",cleanKey(row.data.Site ) !== cleanKey(this.state.selectedSite)," >> ",row.data)
            }
            if (cleanKey(row.data.Site ) !== cleanKey(this.state.selectedSite)) {
                continue
            }
            let fields=[];
            const uniqueKey = row.uniquekey;
            fields.push(uniqueKey);
            for(let a in attributes){
                fields.push(attributes[a])
            }
            row.fullName =this.getEmployeeOption(fields,row.data)
            ls.push(row)
        }
        console.log("renderEmployeeBox > ",ls)
        ls = FilterArrayByKey( ls,{})
        ls = ArrayToSelectOption(ls,["ref"],["fullName"])

        return(
            <BoxSelect
                _this={this}
                handleInput={this.handleChangeInput}
                handleInput2={this.handleChangeInput}
                label={"Employee"}
                ls={ls}
                files={this.state.Files}
                stateKey={"key"}
                val={"val"}
                getHandleValue={this.handleGetInputValue}
                name={"selectedEmployee"}
            />
        )

        return(
            <SearchComboBox
                _this={this}
                handleInput={this.handleChangeInput}
                label={"Employee666"}
                ls={ls}
                stateKey={"key"}
                val={"val"}
                getHandleValue={this.handleGetInputValue}
            />
        )
        return (
            <ControllerSelectBox
                handleInput2={this.handleChangeInput}
                getHandleValue={this.handleGetInputValue}
                ls={ls}
                label={"Employee"}
                name={"selectedEmployee"}
            />
        )
    }

    render() {
        return(
            <Page {...this.props}>
                <div style={{
                    minHeight: "100%",
                    maxHeight: "100%",
                }}>
                    <Title style={styles.title}>Deduction Logging</Title>
                    <div style={{minWidth: "100%", padding: 10}}>

                        <Row gutter={18}>
                            <Col span={12} >
                                {this.renderCompanyBox()}
                            </Col>
                            <Col span={12} >
                                {this.renderProjectBox()}
                            </Col>
                        </Row>
                        <Row gutter={18}>
                            <Col span={12} >
                                {this.renderPayCycleBox()}
                            </Col>
                            <Col span={12} >
                                {this.renderSiteBox()}
                            </Col>
                        </Row>
                        <Row gutter={18}>
                            <Col span={24} >
                                {this.renderCategory()}
                            </Col>
                        </Row>
                        <div style={{
                            borderRadius:5,
                            borderWidth:1,
                            borderColor:"blue",
                            borderStyle:'solid',
                            minHeight:35,
                            padding:10
                        }}>
                            <Row gutter={18}>
                                <Col span={24} >
                            <h4 style={{color:"blue",}}>
                                <u>NEW DEDUCTION FORM</u>
                            </h4>
                                </Col>
                            </Row>
                            <Row gutter={18}>
                                <Col span={8} >
                                    {this.renderEmployeeBox()}
                                </Col>
                                <Col span={10} >
                                    <input
                                        placeholder={"Reason"}
                                        onChange={(e)=>this.handleChangeInput("deductionReason",e.target.value)}
                                        style={{minWidth:"100%",marginTop:10,minHeight:40}}
                                    />
                                </Col>
                                <Col span={3} >
                                    <input
                                        placeholder={"Enter your amount?"}
                                        onChange={(e)=>this.handleChangeInput("deductionAmount",e.target.value)}
                                        style={{minWidth:"100%",marginTop:10,minHeight:40}}
                                        />
                                </Col>
                                <Col span={3} >
                                    <Button
                                        type={"primary"}
                                         style={{minWidth:"100%",
                                             marginTop:10,
                                             marginLeft:5,
                                             minHeight:40,
                                             borderRadius:15,
                                             fontSize:18,
                                             fontWeight:"bold"
                                         }}
                                        onClick={()=>this.submitDeduction()}
                                    >Add Deduction</Button>
                                </Col>
                            </Row>
                        </div>

                    </div>
                </div>
            </Page>
        )
    }

}



export default Connector(DeductionEmployeeRegister);
const styles = {
    container:{

    },
    title: {
        minWidth: "100%",
        borderBottomWidth: 1,
        borderColor: "gray"
    }
}
